import { render, staticRenderFns } from "./GroupAttribute.vue?vue&type=template&id=04872e5c&scoped=true"
import script from "./GroupAttribute.vue?vue&type=script&lang=js"
export * from "./GroupAttribute.vue?vue&type=script&lang=js"
import style0 from "./GroupAttribute.vue?vue&type=style&index=0&id=04872e5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04872e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04872e5c')) {
      api.createRecord('04872e5c', component.options)
    } else {
      api.reload('04872e5c', component.options)
    }
    module.hot.accept("./GroupAttribute.vue?vue&type=template&id=04872e5c&scoped=true", function () {
      api.rerender('04872e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/GroupAttribute.vue"
export default component.exports